import api from './api';
import { User } from '../types';

// Description: Get all employees
// Endpoint: GET /api/employees
// Request: {}
// Response: { employees: User[] }
export const getEmployees = async () => {
  try {
    console.log('API: Fetching employees from /api/employees');
    const response = await api.get('/workmonitor_all');
    console.log('API: Successfully fetched employees:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('API: Error fetching employees:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

export const getActivity = async (date) => {
  try {
    console.log('API: Fetching activity from /api/activity_all');
    const response = await api.get(`/activity_all?workDate=${date}&limit=50&offset=0`);
    console.log('API: Successfully fetched activity:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('API: Error fetching activity:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Get employee by ID
// Endpoint: GET /api/users/:id
// Request: { id: string }
// Response: { employee: User }
export const getEmployeeById = async (id: string) => {
  try {
    console.log(`API: Fetching employee by ID: ${id}`);
    const response = await api.get(`/api/employee/${id}`);
    console.log('API: Successfully fetched employee:', response.data);
    return { employee: response.data };
  } catch (error: any) {
    console.error(`API: Error fetching employee ${id}:`, error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Create new employee
// Endpoint: POST /api/users
// Request: { employee: Partial<User> }
// Response: { success: boolean, message: string, employee: User }
export const createEmployee = async (employee) => {
  employee.weeks = [
    {
      sunday: employee.sunday,
      monday: employee.monday,
      tuesday: employee.tuesday,
      wednesday: employee.wednesday,
      thursday: employee.thursday,
      friday: employee.friday,
      saturday: employee.saturday
    }
  ];
  [
    "sunday",
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
  ].forEach((key) => delete employee[key]);

  try {
    // console.log('API: Creating new employee:', aQ    employee);
    const response = await api.post('/add_workmonitor', {
      ...employee
    });
    // console.log('API: Successfully created employee:', response.data);
    return {
      success: true,
      message: response.data.message,
      employee: response.data
    };
  } catch (error: any) {
    console.error('API: Error creating employee:', error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Add these functions to your existing api/moniter.js file

export const getActivitySetting = async () => {
  try {
    const response = await api.get("/activity_setting");
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

export const updateActivitySetting = async (data) => {
  try {
    const response = await api.post("/activity_setting", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Description: Update employee
// Endpoint: PUT /api/employees/:id
// Request: { id: string, employee: Partial<User> }
// Response: { success: boolean, message: string, employee: User }
export const updateEmployeeStartStop = async (id: string, isActive: boolean, isOvertime: boolean) => {
  try {
    console.log(`API: Updating employee ${id} status to ${isActive}`);
    const response = await api.put(`https://api-socket.startupkhata.com/ws/workmonitor/start/${id}?start=${isActive}&is_overtime=${isOvertime}`);
    console.log('API: Successfully updated employee status:', response.data);
  } catch (error: any) {
    console.error(`API: Error updating employee ${id} status:`, error);
    throw new Error(error?.response?.data?.detail || error.message);
  }
}

export const updateEmployee = async (id: string, employee: Partial<User>) => {
  try {
    console.log(`API: Updating employee ${id}:`, employee);
    // const updateData: any = {};

    // Only include 
    //  that are provided

    employee.weeks = [{
      sunday: employee.sunday,
      monday: employee.monday,
      tuesday: employee.tuesday,
      wednesday: employee.wednesday,
      thursday: employee.thursday,
      friday: employee.friday,
      saturday: employee.saturday
    }]
    // if (employee.name !== undefined) updateData.name = employee.name;
    const response = await api.put(`/update_workmonitor/${id}`, employee);
    console.log('API: Successfully updated employee:', response.data);
    return {
      success: true,
      message: response.data.message,
      employee: response.data.employee
    };
  } catch (error: any) {
    console.error(`API: Error updating employee ${id}:`, error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Delete employee
// Endpoint: DELETE /api/users/:id
// Request: { id: string }
// Response: { success: boolean, message: string }
export const deleteEmployee = async (id: string) => {
  try {
    console.log(`API: Deleting employee ${id}`);
    const response = await api.delete(`/workmonitor_delete`, { data: [id] });
    console.log('API: Successfully deleted employee:', response.data);
    return {
      success: true,
      message: response.data.message
    };
  } catch (error: any) {
    console.error(`API: Error deleting employee ${id}:`, error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};

// Description: Seed database with sample employee data
// Endpoint: POST /api/employees/seed
// Request: {}
// Response: { success: boolean, message: string, created_count: number, skipped_count: number, created_employees: User[], default_password: string }
export const seedEmployees = async () => {
  try {
    console.log('API: Seeding sample employee data');
    const response = await api.post('/api/employees/seed');
    console.log('API: Successfully seeded employee data:', response.data);
    return response.data;
  } catch (error: any) {
    console.error('API: Error seeding employee data:', error);
    throw new Error(error?.response?.data?.detail || error?.response?.data?.error || error.message);
  }
};

export const sendEmail = async (to: string, subject: string, message: string) => {
  try {
    console.log("API: Sending email to:", to);
    const response = await api.post('/api/send-email', {
      to,
      subject,
      message,
    });
    console.log("API: Email sent successfully:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("API: Error sending email:", error);
    throw new Error(error?.response?.data?.error || error.message);
  }
};
